<div>
  <form [formGroup]="confirmationForm">
    <div>
      To McKay Brothers and its Affiliates,
    </div>
    <br>
    <div>
      McKay Brothers, LLC and/or its Affiliates (“McKay”) and {{ loggedInUser.company.name }} (“Company”) entered into
      that certain <b> {{ loggedInUser.company.ndaDocumentTitle }} </b> with an effective date of
      <b> {{ loggedInUser.company.ndaExecutionDate | date: 'dd/MM/yyyy' }}</b>, including all amendments thereto
      (together, the “NDA”). Please be advised that Company hereby designates {{ newUser.name }} as a
      Representative of Company, as that term is used in the NDA.
    </div>
    <div>
      Notwithstanding anything to the contrary in the NDA, Company hereby authorizes {{ newUser.name }}, in
      connection with Representative’s service to Company, to (i) receive McKay’s Confidential Information (as that term
      is used in the NDA) directly from McKay on behalf of Company; and (ii) provide Company’s Confidential Information
      to
      McKay, to be held and used by McKay in accordance with the terms and conditions of the NDA.
    </div>
    <div>
      Company has informed Representative of the confidentiality and non-use obligations of the NDA and confirms that
      (i)
      Representative has a need to know the Confidential Information in connection with its service to the Company and
      (ii)
      Representative is bound by confidentiality and non-use obligations on materially the same terms as those contained
      in
      the NDA. Without limiting the foregoing, it is understood and agreed that Representative may only use McKay’s
      Confidential Information to provide services to Company in support of the business relationship between Company
      and
      McKay, and for no other purpose. Company shall be responsible for any failure of Representative to comply with the
      confidentiality and non-use obligations of the NDA.
    </div>
    <div>
      This authorization will be effective as of {{ dateSigned }} and will continue in full force and effect for as long
      as
      the NDA is in effect, unless the authorization is earlier withdrawn by Company by written notice to McKay.
    </div>

    <br>
    <div>
      The authorization is specific to the following individual(s) within Representative’s organization (if left blank,
      the authorization will be a blanket authorization as to Representative):
    </div>
    <br>

    <div class="col-12 col-md-12 col-lg-12">
      <div class="col-12 col-md-8 col-lg-7">
        <div class="form-group row">
          <div class="col-md-5">
            <label for="newUserName">Name:</label>
          </div>
          <div class="pl-2 col-md-7">
            <input class="form-control" formControlName="newUserName" id="newUserName" type="text">
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-5">
            <label for="newUserTitle">Title:</label>
          </div>
          <div class="pl-2 col-md-7">
            <input class="form-control" formControlName="newUserTitle" id="newUserTitle" type="text">
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-5">
            <label for="thirdPartyCompanyName">Representative’s organization*:</label>
          </div>
          <div class="pl-2 col-md-7">
            <input class="form-control" formControlName="thirdPartyCompanyName" id="thirdPartyCompanyName" type="text">
            <span *ngIf="confirmationForm.get('thirdPartyCompanyName').invalid && this.isFormSubmitted"
                  style="color: red">This field is required</span>
          </div>
        </div>
      </div>
    </div>

    <br>
    <div>
      <b>{{ loggedInUser.company.name | uppercase }}:</b>
    </div>
    <br>

    <div class="col-12 col-md-12 col-lg-12">
      <div class="col-12 col-md-8 col-lg-7">
        <div class="form-group row">
          <div class="col-md-5">
            <label for="productCode">Signed by (Print name)*:</label>
          </div>
          <div class="pl-2 col-md-7">
            <input class="form-control" formControlName="signedBy" id="productCode" type="text">
            <span *ngIf="confirmationForm.get('signedBy').invalid && this.isFormSubmitted" style="color: red">This field is required</span>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-5">
            <label for="dateReported">Date:</label>
          </div>
          <div class="pl-2 col-md-7">
            <input class="form-control" formControlName="dateSigned" id="dateReported" type="text">
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-5">
            <label for="email">Email:</label>
          </div>
          <div class="pl-2 col-md-7">
            <input class="form-control" formControlName="email" id="email" type="text">
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-5">
            <label for="ip">IP Address:</label>
          </div>
          <div class="pl-2 col-md-7">
            <input class="form-control" formControlName="ipAddress" id="ip" type="text">
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="buttons-margin-left pull-right">
    <button (click)="onSubmit()" class="btn btn-outline-danger">
      <i aria-hidden="true" class="fa fa-check-circle pr-2"></i>
      Confirm
    </button>
    <button (click)="closePopUp()" class="btn btn-outline-primary" style="margin-left: 5px;">
      <i aria-hidden="true" class="fa fa-close pr-2"></i>
      Cancel
    </button>
    <br><br>
  </div>
</div>
